import { get } from "lodash";

import store from "@/store"
import MainJwtServices from "@/@core/api/services/main";
import SharedJwtServices from "@/@core/api/services/shared";
import jwtDefaultConfig from '@/@core/api/jwt/jwtDefaultConfig';


export default class JwtService {
  // Will be used by this service for making API calls
  axiosIns = null

  // jwtConfig <= Will be used by this service
  jwtConfig = { ...jwtDefaultConfig }

  // For Refreshing Token
  isAlreadyFetchingAccessToken = false

  // For Refreshing Token
  subscribers = [];

  // Services;
  authService = null;

  mainService = null;

  userService = null;

  sharedService = null;

  constructor(axiosIns, jwtOverrideConfig) {
    this.axiosIns = axiosIns

    this.jwtConfig = { ...this.jwtConfig, ...jwtOverrideConfig }

    this.mainService = new MainJwtServices(this.axiosIns, this.jwtConfig);

    this.sharedService = new SharedJwtServices(this.axiosIns, this.jwtConfig);

    // Request Interceptor
    this.axiosIns.interceptors.request.use(
      config => {
        // eslint-disable-next-line no-undef
        NProgress.start();
        store.commit(`navigation/UPDATE_FETCHING_REMOTE_DATA`, true)

        // Get token from localStorage
        const accessToken = this.mainService.auth.getAccessToken();
        const hasCustomToken = !!get(config, `headers.Authorization`);

        if (!hasCustomToken && accessToken) {
          config.headers.Authorization = `${this.jwtConfig.tokenType} ${accessToken}`
        }
        return config
      },
      error => {
        // eslint-disable-next-line no-undef
        NProgress.done();
        store.commit(`navigation/UPDATE_FETCHING_REMOTE_DATA`, false)

        Promise.reject(error)
      }
    );

    this.axiosIns.interceptors.response.use(
      response => {
        // eslint-disable-next-line no-undef
        NProgress.done()
        store.commit(`navigation/UPDATE_FETCHING_REMOTE_DATA`, false)
        return response;
      },
      (error) => {
        const invalidTokenErrors = ["invalid token", "invalid access token.", "invalid signature", "invalid or expired token."];

        const errorMessage = get(error, "response.data.message", "").toLowerCase()
        const isInvalidTokenError = invalidTokenErrors.includes(errorMessage);

        if (error && error.response && [403, 500].includes(error.response.status) && isInvalidTokenError) {
          this.mainService.auth.clearAccessToken();
        }
        // eslint-disable-next-line no-undef
        NProgress.done();
        store.commit(`navigation/UPDATE_FETCHING_REMOTE_DATA`, false)
        return Promise.reject(error);
      }
    );
  }

  onAccessTokenFetched(accessToken) {
    this.subscribers = this.subscribers.filter(callback => callback(accessToken))
  }

  addSubscriber(callback) {
    this.subscribers.push(callback)
  }
}
